import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Paper from '@material-ui/core/Paper';

import ReportFilters from './ReportFilters';


const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    }
}));

const WeddingsBookedByDateReport = () => {
    const classes = useStyles();
    const reportUrl = '/api/reports/weddings-booked-by-date';
    const reportTitle = 'Weddings Booked By Date';
    const pageTitle = `${reportTitle} - Enduring Promises`;
    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const now = new Date();
    const defaultDate = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate(), now.getHours() + 1, 0, 0);

    const formatDate = val => {
        const month = val.getMonth() + 1;
        const day = val.getDate();
        return `${val.getFullYear()}-${month < 10 ? '0'+month : month}-${day < 10 ? '0'+day : day}`;
    }

    const [state, setState] = React.useState({
        year: new Date().getFullYear(),
        date: formatDate(defaultDate)
    });

    const getData = (year, date) => {
        new Promise((resolve, reject) => {
            fetch(`${reportUrl}?year=${year}&date=${date}`)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        document.title = pageTitle;
        getData(state.year, state.date);
    }, [1]);

    const handleSubmit = () => {
        getData(state.year, state.date);
    };

    return (
        <Paper square className={classes.paper}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{reportTitle}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <ReportFilters state={state} setState={setState} handleSubmit={handleSubmit} />
                </Grid>
                <Grid item xs={12}>
                    {loading && 'Loading...'}
                    {!loading && data !== null && (
                        <div>
                            {data} {data != 1 ? 'weddings' : 'wedding'}
                        </div>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
}

export default WeddingsBookedByDateReport;
